export const shareSocial = {
  linkedin: (link = '') => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`,
  facebook: (link = '') => `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
  twitter: (link = '', message = '') =>
    `https://twitter.com/intent/tweet/?text=${encodeURIComponent(message)}&url=${encodeURIComponent(link)}`,
};
